import React, { useEffect, useRef, useState } from 'react'
import event_tab_img from '../../assets/images/event_tab_img.png'
import EventPopup from '../EventPopup'
import PaginationButtons from '../PaginationButtons';
const EventAllTabSection = () => {
    const popupRef = useRef();
    const popupInnerRef = useRef();
    const popupOpenRefs = useRef([]);
    const [isPopupClose, setPopupClose] = useState(true);
    const [isPopupClosing, setPopupClosing] = useState(true);

    const [events, setEvents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const pageSize = 30;

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const res = await fetch(`https://api.1000siljang.xyz/api/users/events?page=${currentPage}&size=${pageSize}`, {
                    headers: {
                        accept: 'application/json'
                    }
                });
                const data = await res.json();
                setEvents(data.data || data); 
                setTotalPages(data.total_pages || 1); 
            } catch (err) {
                console.error("Error fetching events:", err);
            }
        };
        fetchEvents();
    }, [currentPage]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    const handlePopupOpen = async (eventId) => {

        try {
            const res = await fetch(`https://api.1000siljang.xyz/api/users/events/${eventId}`, {
                headers: { accept: 'application/json' },
            });
            const data = await res.json();
            setSelectedEvent(data);
            setPopupClosing(false);
            setPopupClose(false);
        } catch (error) {
            console.error("Failed to fetch event details:", error);
        }

        // const popupCurrent = popupRef.current;
        // if (popupCurrent) {
        //     //   popupCurrent.classList.remove('hidden');
        //     //   popupCurrent.classList.add('open-popup');
        //     //   popupCurrent.classList.remove('close-popup');
        //     setPopupClose(false)
        //     setPopupClosing(false)
        // }
    };

    const handlePopupClose = () => {
        const popupCurrent = popupRef.current;
        if (popupCurrent) {
            setPopupClosing(true)
            //   popupCurrent.classList.remove('open-popup');
            //   popupCurrent.classList.add('close-popup');

            const onAnimationEnd = () => {
                setPopupClose(true)
                setPopupClosing(true)
                // popupCurrent.classList.add('hidden');
                popupCurrent.removeEventListener('animationend', onAnimationEnd);
            };

            popupCurrent.addEventListener('animationend', onAnimationEnd);
        }
    };

    const addToRefs = (el, index) => {
        if (el && !popupOpenRefs.current.includes(el)) {
            popupOpenRefs.current[index] = el;
        }
    };
    useEffect(() => {
        const handleOutSideClick = (e) => {
            if (popupInnerRef.current && !popupInnerRef.current.contains(e.target) && !popupOpenRefs.current.some(ref => ref && ref.contains(e.target))) {
                handlePopupClose()
            }
        }
        document.addEventListener('click', handleOutSideClick)
        return () => {
            document.removeEventListener('click', handleOutSideClick)
        }
    }, [isPopupClose, isPopupClosing])
    return (
        <>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2.5 lg:gap-4 p-0.5'>
                {events.map((event, index) => (
                    <div key={event.id} className='w-full transition-[0.4s] duration-[ease-out] relative border bg-charcoal border-charcoal'>
                        <button
                            className='group'
                            onClick={() => handlePopupOpen(event.id)}
                            ref={(el) => addToRefs(el, index)}
                        // onClick={handlePopupOpen} 
                        // ref={(el) => addToRefs(el, index)}
                        >
                            <div className="cursor-pointer">
                                <img
                                    src={event.thumbnail_image_url || event_tab_img}
                                    alt={event.title}
                                    loading='lazy'
                                    className='w-full h-auto transition-all duration-[0.4s] ease-in-out relative group-hover:z-[2] group-hover:scale-110'
                                />
                            </div>
                            <div className="p-2 hidden">
                                <h3 className="text-white text-sm font-bold whitespace-nowrap overflow-hidden text-ellipsis">
                                    <span className='text-gold'>♥</span> {event.title} <span className='text-gold'>♥</span>
                                </h3>
                                <strong className="text-white no-underline bg-graphite text-xs cursor-pointer transition-[0.3s] duration-[ease-out] px-2 py-1 rounded-[20px] block mt-1">
                                    상세보기
                                </strong>
                            </div>
                        </button>
                    </div>
                ))}
            </div>
            <div className='mt-3'>
                <PaginationButtons totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
            </div>
            <EventPopup
                popupRef={popupRef}
                popupInnerRef={popupInnerRef}
                onClose={handlePopupClose}
                isPopupClose={isPopupClose}
                isPopupClosing={isPopupClosing}
                event={selectedEvent}
            />
        </>
    )
}

export default EventAllTabSection